import { render } from "./SalesTable.vue?vue&type=template&id=641ae382&scoped=true"
import script from "./SalesTable.vue?vue&type=script&lang=js"
export * from "./SalesTable.vue?vue&type=script&lang=js"

import "./SalesTable.vue?vue&type=style&index=0&id=641ae382&scoped=true&lang=css"

import exportComponent from "G:\\dev\\OSPanel\\domains\\arenda-frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-641ae382"]])

export default __exports__